import { render, staticRenderFns } from "./communityShare.vue?vue&type=template&id=55a5dc9c&scoped=true"
import script from "./communityShare.vue?vue&type=script&lang=js"
export * from "./communityShare.vue?vue&type=script&lang=js"
import style0 from "./communityShare.vue?vue&type=style&index=0&id=55a5dc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a5dc9c",
  null
  
)

export default component.exports